export default "__VITE_ASSET__3fdca382__"